import moment from 'moment';
import IconWithText from '../icon-with-text/IconWithText.component';
import { getHourAndMinuteFromSecond } from '../../utilities/remediation.utilities';

export type TimeEstimateDisplayProps = {
  timeEstimateDuration: string;
}
export const TimeEstimateDisplay = (props: TimeEstimateDisplayProps): JSX.Element => {
  return (
    <IconWithText
      iconName="clock"
      iconPrefix="gizmo"
    >
      <span>
        est.
        {getHourAndMinuteFromSecond(moment.duration(props.timeEstimateDuration).asSeconds())}
      </span>
    </IconWithText>
  );
};
